import type { ReactNode } from "react";

type PhoneFrameProps = {
  children: ReactNode;
  /** Extra sizing/positioning classes for the outer shell. */
  className?: string;
  /** Extra classes for the notch, which scales with the shell. */
  notchClassName?: string;
};

/** Dark phone bezel used around the app screenshots in the hero and feature cards. */
export function PhoneFrame({
  children,
  className = "",
  notchClassName = "",
}: PhoneFrameProps) {
  return (
    <div
      className={`relative z-[1] shrink-0 border border-[#2B2B34] bg-[#0A0A0D] shadow-[0_26px_52px_rgba(0,0,0,0.55),inset_0_0_0_2px_#050506] ${className}`}
    >
      <span
        aria-hidden="true"
        className={`absolute left-1/2 z-[2] h-1 -translate-x-1/2 rounded-full bg-[#2F2F39] ${notchClassName}`}
      />
      {children}
    </div>
  );
}
